import FontFaceObserver from "fontfaceobserver";

export const FONT_NORMAL = 400;
export const FONT_SEMIBOLD = 600;
export const FONT_BOLD = 700;

export const FONT_CENTRIC8 = "Centric8";
export const FONT_MATERIAL_ICONS = "Material Icons";

/** Load font in given weight within a given timeout in milliseconds (default is 3000) */
export async function loadFont(font: string, weight: number, timeout?: number): Promise<void> {
	const ffo = new FontFaceObserver(font, { weight });
	return ffo.load(null, timeout || 3000);
}

/** Load fonts necessary for printing within a given timeout in milliseconds (default is 3000) */
export async function loadFontsForPrint(timeout?: number): Promise<void[]> {
	return Promise.all([
		loadFont(FONT_CENTRIC8, FONT_NORMAL, timeout),
		loadFont(FONT_CENTRIC8, FONT_SEMIBOLD, timeout),
		loadFont(FONT_CENTRIC8, FONT_BOLD, timeout),
		loadFont(FONT_MATERIAL_ICONS, FONT_NORMAL, timeout),
	]);
}
